package com.yogaaicoach.common.network

import io.ktor.client.plugins.api.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import kotlinx.coroutines.CompletableJob

class AuthRetryPluginConfig {
    lateinit var shouldRetry: suspend (HttpRequest, HttpResponse) -> Boolean
    var modifyRequest: (HttpRequestBuilder) -> Unit = {}

    fun modifyRequest(block: (HttpRequestBuilder) -> Unit) {
        modifyRequest = block
    }

    fun retryIf(
        block: suspend (HttpRequest, HttpResponse) -> Boolean
    ) {
        shouldRetry = block
    }
}

/**
 * Plugin to retry request after failure. If shouldRetry conditions is true.
 * Use case. E.g. When request fails because accessToken is expired.
 *      Then new access token is requested and retry request has made with new accessToken
 */
val AuthRetryPlugin: ClientPlugin<AuthRetryPluginConfig> = createClientPlugin(
    "AuthRetryPlugin",
    ::AuthRetryPluginConfig
) {
    val shouldRetry: suspend (HttpRequest, HttpResponse) -> Boolean = pluginConfig.shouldRetry
    val modifyRequest: (HttpRequestBuilder) -> Unit = pluginConfig.modifyRequest

    fun prepareRequest(request: HttpRequestBuilder): HttpRequestBuilder {
        val subRequest = HttpRequestBuilder().takeFrom(request)
        request.executionContext.invokeOnCompletion { cause ->
            val subRequestJob = subRequest.executionContext as CompletableJob
            if (cause == null) {
                subRequestJob.complete()
            } else subRequestJob.completeExceptionally(cause)
        }
        return subRequest
    }

    on(Send) { request ->
        val subRequest = prepareRequest(request)
        var call = proceed(subRequest)

        if (shouldRetry(call.request, call.response)) {
            modifyRequest(subRequest)
            call = proceed(subRequest)
        }
        call
    }
}